import { render, staticRenderFns } from "./OrderList.vue?vue&type=template&id=1058421c&scoped=true"
import script from "./OrderList.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderList.vue?vue&type=script&setup=true&lang=js"
import style0 from "./OrderList.vue?vue&type=style&index=0&id=1058421c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1058421c",
  null
  
)

export default component.exports